"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var mui_datatables_1 = require("mui-datatables");
/*
const sampleData = {
  type: "TABLE",
  name: "Sample Table Chart",
  table: {
    columns: ['Name', 'Company', 'City', 'State', 'Age'],
    rows: [
      ['Joe James', 'Test Corp', 'Yonkers', 'NY', 20],
      ['John Walsh', 'Test Corp', 'Hartford', 'CT', 29],
      ['Bob Herm', 'Test Corp', 'Tampa', 'FL', 35],
      ['James Houston', 'Test Corp', 'Dallas', 'TX', 54],
    ],
  }
}
*/
var Table = function (_a) {
    var chartData = _a.chartData, tableOptions = _a.tableOptions, columnOptions = _a.columnOptions;
    var rows = chartData ? chartData.table.rows : null;
    var _columns = chartData ? chartData.table.columns : null;
    var columns = rows && _columns
        ? _columns.map(function (column, index) {
            // 空文字は飛ばした最初のvalue
            var firstValue = null;
            for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                var row = rows_1[_i];
                firstValue = row[index];
                if (row[index] && row[index] !== '') {
                    break;
                }
            }
            var columnOption = columnOptions ? columnOptions[column] || {} : {};
            // nullは「-」に変換する
            columnOption.customBodyRender = function (value) {
                return value === null ? '-' : value;
            };
            // 値(の1つ目)が数値型の場合、右揃え&カンマを追加&ソートを数値変換して行う
            if (firstValue && firstValue.match(/^\d+(\.\d+)?%?$/)) {
                columnOption.setCellProps = function () { return ({
                    style: {
                        textAlign: 'right'
                    }
                }); };
                columnOption.sortCompare = function (order) {
                    return function (obj1, obj2) {
                        var value1 = Number(obj1.data ? obj1.data.replace(/%$/, '') : -999);
                        var value2 = Number(obj2.data ? obj2.data.replace(/%$/, '') : -999);
                        return (value1 - value2) * (order === 'asc' ? 1 : -1);
                    };
                };
                columnOption.customBodyRender = function (value) {
                    if (value === null) {
                        return '-';
                    }
                    else if (value.match(/.*%$/)) {
                        return Number(value.replace(/%$/, '')).toLocaleString() + '%';
                    }
                    else {
                        return Number(value).toLocaleString();
                    }
                };
            }
            return {
                name: column,
                options: columnOption
            };
        })
        : null;
    var title = ''; // probably not needed  chartData ? chartData.name : undefined;
    var options = __assign({ elevation: 1, filter: false, filterType: 'checkbox', download: false, pagination: false, print: false, search: false, viewColumns: false, selectableRows: 'none', responsive: 'standard' }, tableOptions);
    return columns && rows ? (0, jsx_runtime_1.jsx)(mui_datatables_1["default"], { title: title, columns: columns, data: rows, options: options }) : null;
};
exports["default"] = Table;
